import { Avatar } from "ui/atoms/avatar";
import { View } from "ui/atoms/view";
import { Text } from "react-native";

interface Props {
  image?: string;
  profile?: { first_name: string; last_name: string };
  subtitle?: string;
}

export const ProfileMenu = ({ image, profile, subtitle }: Props) => {
  return (
    <View className="flex-row gap-2 items-center">
      <Avatar image={image} profile={profile} />
      <View>
        <Text className="font-medium overflow-hidden ">
          {`${profile?.first_name ?? ""} ${profile?.last_name ?? ""}`.trim()}
        </Text>
        {subtitle ? (
          <Text className="font-base text-xs overflow-hidden ">{subtitle}</Text>
        ) : null}
      </View>
    </View>
  );
};
